/**
 * Admin Portal → Users → user detail → Partner (partner launch, workstream S5).
 *
 * Which partner (if any) this account came through: the partner and tag, whether it was
 * attributed — and if not, why not —, how it was captured, how an offer was applied, and the
 * partner contact it is linked to (linked via a personal link, a code or an email match, and
 * when), with the event facts the partner gave. Read from the user detail answer's `partner`
 * (S1, docs/plans/PARTNER_LAUNCH_PLAN_2026_10_17.md §6–§7); the rows are built by the pure
 * `userPartnerRows` (jest-pinned).
 *
 *   - `partner` absent (an older server): the section is not shown — never "no partner" when the
 *     server simply did not say;
 *   - `partner: null`: "No partner source on this account.";
 *   - an object: one labelled row per fact.
 *
 * Never a contact's email address or last name. Web-only (the admin SPA).
 */

import React from 'react';
import { userPartnerRows, type UserPartnerInfo } from '../../pages/admin/partners/partnerContactsLogic';

export const UserPartnerSection: React.FC<{ partner: UserPartnerInfo | null | undefined }> = ({ partner }) => {
  if (partner === undefined) return null;
  return (
    <div className="bg-gray-50 rounded-md p-3" data-testid="user-partner-section">
      <h3 className="text-sm font-semibold text-gray-900 mb-2">Partner</h3>
      {partner === null ? (
        <p className="text-sm text-gray-500">No partner source on this account.</p>
      ) : (
        <div className="grid grid-cols-3 gap-3">
          {userPartnerRows(partner).map(([k, v]) => (
            <div key={k}>
              <label className="text-xs text-gray-500">{k}</label>
              <p className="text-sm text-gray-900">{v}</p>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default UserPartnerSection;
